export const headerOptions = [
  {
    value: 'Candidate summary',
    label: 'Candidate summary',
    key: 'candidate_summary',
  },
  {
    value: 'Question and answer',
    label: 'Question and answer',
    key: 'questions',
  },
  {
    value: 'Topic highlights',
    label: 'Topic highlights',
    key: 'topics',
  },
  {
    value: 'Recruiter screen',
    label: 'Candidate fit',
    key: 'recruiter_screen',
  },
  {
    value: 'Highlights & lowlights',
    label: 'Highlights & lowlights',
    key: 'highlights_and_lowlights',
  },
];

export const TIMELINE_COLORS = ['#5653F6', '#2796B8', '#F65397', '#56A073'];

export const INTERVIEW_DETAILS_VIEW_SIZE = [30, 70];

export const SEND_MESSAGE_CONFIG = (
  interviewName: string,
  candidateName: string
) => [
  {
    id: 'need-reschedule',
    text: 'I need this interview rescheduled',
    message: `<p>Unfortunately, I won't be able to make it to the ${interviewName} with ${candidateName}. Can you please reschedule this interview to a later time?</p>`,
    skipCandidate: true,
  },
  {
    id: 'need-more-info',
    text: 'I need more information',
    message: `<p>I am preparing for the ${interviewName} with ${candidateName}. Can you help with more information on the job and ${candidateName}?</p>`,
    skipCandidate: true,
  },
  {
    id: 'late-to-interview',
    text: 'I will be late to the interview',
    message: `<p>Unfortunately, I will be late for ${interviewName} by 5 minutes. Thank you for your patience, and I apologize for the inconvenience.</p>`,
    skipCandidate: false,
  },
  {
    id: 'change-venue',
    text: 'Change in venue or the meeting link',
    message: `<p>Heads-up, there is a slight change in the location of this interview. Please find the updated details below</p>
<p><em>{The updated details go here}</em></p>`,
    skipCandidate: false,
  },
  {
    id: 'custom-message',
    text: 'Custom message',
    message: ``,
    skipCandidate: false,
  },
];

export const interviewIntelligenceStatusMap = {
  completed: {
    label: 'AI recording ready',
    bg: 'pastel-3-light',
    color: 'pastel-3-dark',
    value: 'completed',
  },
  failed: {
    label: 'AI recording failed',
    bg: 'pastel-1-light',
    color: 'pastel-1-dark',
    value: 'failed',
  },
  no_recording: {
    label: 'No AI recording',
    bg: 'pastel-1-light',
    color: 'pastel-1-dark',
    value: 'no_recording',
  },
  recording_permission_denied: {
    label: 'AI recording denied',
    bg: 'pastel-1-light',
    color: 'pastel-1-dark',
    value: 'recording_permission_denied',
  },
  scheduled: {
    label: 'AI notetaker enabled',
    bg: 'pastel-3-light',
    color: 'pastel-3-dark',
    value: 'scheduled',
  },
  pending: {
    label: 'AI pending',
    bg: 'pastel-3-light',
    color: 'pastel-3-dark',
    value: 'pending',
  },
  recording: {
    label: 'AI recording now',
    bg: 'pastel-3-light',
    color: 'pastel-3-dark',
    value: 'recording',
  },
  in_waiting_room: {
    label: 'AI waiting',
    bg: 'pastel-6-light',
    color: 'pastel-6-dark',
    value: 'in_waiting_room',
  },

  processing: {
    label: 'AI processing',
    bg: 'pastel-6-light',
    color: 'pastel-6-dark',
    value: 'processing',
  },
};

export const interviewStatusMap = {
  not_started: {
    label: 'Interview scheduled',
    bg: 'pastel-2-light',
    color: 'pastel-2-dark',
    value: 'not_started',
  },
  in_progress: {
    label: 'Interview in-progress',
    bg: 'pastel-2-light',
    color: 'pastel-2-dark',
    value: 'in_progress',
  },
  ended: {
    label: 'Interview completed',
    bg: 'pastel-2-light',
    color: 'pastel-2-dark',
    value: 'ended',
  },
  cancelled: {
    label: 'Interview canceled',
    bg: 'pastel-1-light',
    color: 'pastel-1-dark',
    value: 'cancelled',
  },
  candidate_no_show: {
    label: 'Candidate no-show',
    bg: 'pastel-1-light',
    color: 'pastel-1-dark',
    value: 'candidate_no_show',
  },
};

// Merged FE-only intelligence statuses for display/filtering
export const interviewIntelligenceMergedStatusMap = {
  completed: {
    label: 'AI recording ready',
    keys: ['completed'],
  },
  failed: {
    label: 'AI recording failed',
    keys: ['failed', 'no_recording'],
  },
  denied: {
    label: 'AI recording denied',
    keys: ['recording_permission_denied'],
  },
  enabled: {
    label: 'AI notetaker enabled',
    keys: ['scheduled', 'pending'],
  },
  recording: {
    label: 'AI recording now',
    keys: ['recording'],
  },
  waiting: {
    label: 'AI waiting',
    keys: ['in_waiting_room'],
  },
  processing: {
    label: 'AI processing',
    keys: ['processing'],
  },
};
